var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBranchesNewActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83341 6.66699H3.33341C2.41675 6.66699 1.66675 5.91699 1.66675 5.00033V3.33366C1.66675 2.41699 2.41675 1.66699 3.33341 1.66699H5.83341C6.75008 1.66699 7.50008 2.41699 7.50008 3.33366V5.00033C7.50008 5.91699 6.75008 6.66699 5.83341 6.66699Z",
    stroke: "#1A6D73",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 5.83333H14.3332C13.7832 5.83333 13.3333 5.38332 13.3333 4.83332V3.50001C13.3333 2.95001 13.7832 2.5 14.3332 2.5H17.3333C17.8833 2.5 18.3333 2.95001 18.3333 3.50001V4.83332C18.3333 5.38332 17.8833 5.83333 17.3333 5.83333Z",
    stroke: "#1A6D73",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 12.0833H14.3332C13.7832 12.0833 13.3333 11.6333 13.3333 11.0833V9.75001C13.3333 9.20001 13.7832 8.75 14.3332 8.75H17.3333C17.8833 8.75 18.3333 9.20001 18.3333 9.75001V11.0833C18.3333 11.6333 17.8833 12.0833 17.3333 12.0833Z",
    stroke: "#1A6D73",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 4.16699H13.3333",
    stroke: "#1A6D73",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4167 13.6338V15.0005C10.4167 15.9171 11.1667 16.6671 12.0834 16.6671H13.3334",
    stroke: "#1A6D73",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4167 4.16699V10.267",
    stroke: "#1A6D73",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 10.417H10.4167",
    stroke: "#1A6D73",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 18.3333H14.3332C13.7832 18.3333 13.3333 17.8833 13.3333 17.3333V16C13.3333 15.45 13.7832 15 14.3332 15H17.3333C17.8833 15 18.3333 15.45 18.3333 16V17.3333C18.3333 17.8833 17.8833 18.3333 17.3333 18.3333Z",
    stroke: "#1A6D73",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBranchesNewActive);
export default __webpack_public_path__ + "static/media/branchesNewActive.f4d00fc1ece55b2f24b2c4144931e907.svg";
export { ForwardRef as ReactComponent };